export default "__VITE_ASSET__BQluxjW3__"